import { ServiceIcon, Text } from "@zapier/design-system";

import isNumber from "../../../utils/isNumber";
import getAppIconUrl from "../../../utils/getAppIconUrl";
import useServiceById from "../../../hooks/useServiceById";
import cleanUpAppId from "../../../utils/cleanUpAppId";

import styles from "./IconsList.module.css";

type Props = {
  apps: (string | number)[];
};

export const IconsList = ({ apps }: Props) => {
  const getService = useServiceById();

  return (
    <ul className={styles.tidyList} aria-label="Summary list of apps">
      {apps.map((appId) => {
        const service = getService(appId);
        const images = service?.images;
        const size = 20;

        // If app is a number, it's the middle app count
        const serviceName = isNumber(appId)
          ? `Plus ${appId} more apps`
          : (service?.name ?? cleanUpAppId(appId as string));

        return (
          <li key={appId}>
            <>
              {isNumber(appId) ? (
                <span className={styles.middleApp}>
                  <Text type="MinimalPrint2" color="TextDefault">
                    +{appId}
                  </Text>
                </span>
              ) : (
                <ServiceIcon
                  alt={`${serviceName} icon`}
                  hasBorder={false}
                  size={size}
                  hasShadow={false}
                  serviceName={serviceName}
                  src={getAppIconUrl(appId as string, images, size)}
                />
              )}
            </>
          </li>
        );
      })}
    </ul>
  );
};
